export default __webpack_public_path__ + "static/media/A62.80f454b3.jpg";